"use strict";
$(function ($) {
  /* ドロワーメニュー */
   /* ----- 簡単なハンバーガーメニュー ----- */
  $('#js-hamburger').on('click', function () {
    $('#js-hamburger, #js-drawer-menu').toggleClass('is-openSP');
  });

  $("#js-hamburger").click(function () {
    $(this).toggleClass('active');
  });

  // ハンバーガーメニュー内をクリックしらたらハンバーガーメニューを閉じる
  $('#js-drawer-menu a[href]').on('click', function () {
    $('#js-hamburger').trigger('click')
  });
});

/* ----- qa ----- */
$(".qa__question").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});

$(".megaMenu__btn").on("click", function() {
  $(this).next().slideToggle();
  $(this).toggleClass("is-active");
});

document.addEventListener('DOMContentLoaded', function() {
    const menuBtn = document.querySelector('.menu__btn');
    const menu = document.querySelector('.menu');

    menuBtn.addEventListener('mouseenter', function() {
        menuBtn.classList.add('is-active');
        menu.classList.add('is-active');
    });

    menuBtn.addEventListener('mouseleave', function() {
        menuBtn.classList.remove('is-active');
        menu.classList.remove('is-active');
    });

    menu.addEventListener('mouseenter', function() {
        menuBtn.classList.add('is-active');
        menu.classList.add('is-active');
    });

    menu.addEventListener('mouseleave', function() {
        menuBtn.classList.remove('is-active');
        menu.classList.remove('is-active');
    });
});


// 共通のスライダー設定関数
function initSplide(selector, options) {
  const element = document.querySelector(selector);
  if (element) {
    new Splide(element, options).mount();
  } else {
    console.log(`${selector} element not found`);
  }
}

// DOMが読み込まれたときに実行
document.addEventListener('DOMContentLoaded', function () {
  // FVスライダーの設定
  initSplide('.fv__slider', {
    autoplay: true,
    type: 'loop',
    pauseOnHover: false,
    pauseOnFocus: false,
    pagination: false,
    interval: 5000,
    speed: 1000,
    padding: '8%',
    gap: 37,
    arrows: false,
    classes: {
      pagination: 'splide__pagination your-class-pagination',
      page: 'splide__pagination__page your-class-page',
    },
    breakpoints: {
      768: {
        padding: '10%',
        gap: 20,
      },
    },
  });

  // voice__sliderの設定
  initSplide('.voice__slider', {
    type: 'loop',
    pauseOnHover: false,
    pauseOnFocus: false,
    interval: 2000,
    speed: 1000,
    padding: '15%',
    gap: 30,
    pagination: false,
    breakpoints: {
      768: {
        padding: '10%',
        gap: 20,
      },
    },
  });

  // topCase__sliderの設定
  initSplide('.topCase__slider', {
    focus: 'center',
    autoplay: true,
    arrows: false,
    type: 'loop',
    pauseOnHover: false,
    pauseOnFocus: false,
    interval: 4000,
    speed: 1000,
    padding: '8%',
    gap: 25,
    pagination: true,
    perPage: 3,
    classes: {
      pagination: 'splide__pagination topCase__pagination',
      page: 'splide__pagination__page topCase__page',
    },
    breakpoints: {
      767: {
        padding: '10%',
        gap: 20,
        perPage: 1,
      },
    },
  });
});



/* ----- スムースクロール ----- */
// 固定ヘッダー（固定しない場合は = 0）
const headerHeight = document.querySelector('header').offsetHeight;

// ページ内のスムーススクロール
for (const link of document.querySelectorAll('a[href*="#"]')) {
  link.addEventListener('click', (e) => {
    const hash = e.currentTarget.hash;
    const target = document.getElementById(hash.slice(1));

    // ページトップへ("#"と"#top"）
    if (!hash || hash === '#top') {
      e.preventDefault();
      window.scrollTo({
        top: 1, // iOSのChromeで固定ヘッダーが動くバグがあるため0ではなく1に
        behavior: 'smooth',
      });

    // アンカーへ
    } else if (target) {
      e.preventDefault();
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo({
        top: position,
        behavior: "smooth",
      });

      // URLにハッシュを含める
      history.pushState(null, '', hash);
    }
  });
};

// 別ページ遷移後にスムーススクロール
const urlHash = window.location.hash;
if (urlHash) {
  const target = document.getElementById(urlHash.slice(1));
  if (target) {
    // ページトップから開始（ブラウザ差異を考慮して併用）
    history.replaceState(null, '', window.location.pathname);
    window.scrollTo(0, 0);

    window.addEventListener("load", () => {
      const position = target.getBoundingClientRect().top + window.scrollY - headerHeight;
      window.scrollTo(0, position);

      // ハッシュを再設定
      history.replaceState(null, '', window.location.pathname + urlHash);
    });
  }
}



// /* ----- top-btnの表示 ----- */
// window.onload = function() {
//     // スクロールイベントを監視し、2000px以上スクロールされたらボタンを表示する
//   window.addEventListener("scroll", function() {
//     var scrollButton = document.querySelector(".top-btn");
//     if (document.body.scrollTop > 1000 || document.documentElement.scrollTop > 1000) {
//         scrollButton.style.opacity = 1;
//     } else {
//         scrollButton.style.opacity = 0;
//         setTimeout(function () {
//         }, 500); // アニメーションが終わるまでの時間
//     }
//   });
// };

// ページトップにスクロールする関数
function scrollToTop() {
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
}



/* ----- モーダル表示 ----- */
document.addEventListener('DOMContentLoaded', function () {
  // モーダルボタンを取得
  const modalBtns = document.querySelectorAll('.modal__btn');

  modalBtns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      // クリックされたボタンの次のモーダル要素を取得
      const modal = this.nextElementSibling;
      if (modal && modal.classList.contains('js-modal')) {
        modal.classList.add('is-visible'); // モーダルを表示
      }
    });
  });

  // モーダルの閉じる処理
  document.addEventListener('click', function (event) {
    if (event.target.matches('.js-modal')) {
      event.target.classList.remove('is-visible'); // モーダルを閉じる
    }
  });
});


/* ----- 下部CTA ----- */
document.addEventListener('DOMContentLoaded', () => {
  const fixedLink = document.querySelector('.baner');
  const popElement = document.querySelector('.pop'); // .pop要素も取得

  // 最初は非表示
  fixedLink.style.opacity = '0';
  fixedLink.style.visibility = 'hidden';
  popElement.style.opacity = '0'; // .pop要素も非表示
  popElement.style.visibility = 'hidden';

  document.addEventListener('scroll', () => {
    const scrollTop = window.scrollY;
    const windowHeight = window.innerHeight;
    const documentHeight = document.documentElement.scrollHeight;
    const showAfterScroll = 300; // 300pxスクロールしたら表示

    if (scrollTop + windowHeight >= documentHeight) {
      // ページの一番下に到達したら非表示
      fixedLink.style.opacity = '0';
      fixedLink.style.visibility = 'hidden';
      popElement.style.opacity = '0'; // .popも非表示
      popElement.style.visibility = 'hidden';
    } else if (scrollTop > showAfterScroll) {
      // 300px以上スクロールしたら表示
      fixedLink.style.opacity = '1';
      fixedLink.style.visibility = 'visible';
      popElement.style.opacity = '1'; // .popも表示
      popElement.style.visibility = 'visible';
    } else {
      // それ以外は非表示
      fixedLink.style.opacity = '0';
      fixedLink.style.visibility = 'hidden';
      popElement.style.opacity = '0'; // .popも非表示
      popElement.style.visibility = 'hidden';
    }
  });
});



/* ----- タブ ----- */
document.addEventListener('DOMContentLoaded', function() {
  const tabs = document.querySelectorAll('.tab__item');
  const contents = document.querySelectorAll('.tab__content');
  // .tab__item および .tab__content が存在する場合のみスクリプトを実行
  if (tabs.length > 0 && contents.length > 0) {
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', function() {
        // すべてのタブとコンテンツのクラスをリセット
        tabs.forEach(tab => tab.classList.remove('is-active'));
        contents.forEach(content => content.style.display = 'none');
        // クリックしたタブと対応するコンテンツにクラスとスタイルを適用
        tab.classList.add('is-active');
        contents[index].style.display = 'block';
      });
    });
    // 初期表示で1つ目のコンテンツを表示
    contents.forEach(content => content.style.display = 'none');
    document.querySelector('.tab__content').style.display = 'block';
  }
});


document.querySelector('.pop__btn').addEventListener('click', function() {
    const popElement = document.querySelector('.pop');
    if (popElement) {
        popElement.style.display = 'none';
    }
});
